import React, {useEffect, useRef, useState} from 'react';
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  ScrollView,
  Image,
  ActivityIndicator,
} from 'react-native';
import {useDispatch, useSelector, connect} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../assets';

import {isMobile, loadScript, openURL} from '../../utils/commonMethods';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import Colors from '../../assets/Color/Colors';
import {useFocusEffect} from '@react-navigation/native';
import CommonModal from '../../commonComponents/commonModal';
import {globalConfigurableData, globalConst} from '../../utils/globalConstant';
import {
  htt1,
  htt_rewards,
  previous_earn_arrow,
  profit_arrow,
  smile_coin,
} from '../../utils/images';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import FastImage from '../../common/FastImage';
import PreviousEarnings from './childComponents/PreviousEarnings';
import HowItWorksRewards from './childComponents/HowItWorksRewards';
import Gradient from '../../commonComponents/Gradient';
import {getRewardsMainDetails} from '../rewards/redux/rewards.action';
import {
  REWARDS_EARN_TOKENS,
  REWARDS_TRADE_TOKENS,
} from '../rewards/rewards.constant';
import {TEST_API} from '../../utils/apiUrl';
import {
  hideLoader,
  showLoader,
} from '../../commonComponents/Loader/loader.actions';
import Width from '../../assets/Width';
import {useToast} from '../../components/core/Toast';
import {globalImport} from '../../common/globalImports';
import Header from '../../commonComponents/Header';

let {height, width} = Width;

const RewardsMain = ({route, navigation}) => {
  const { toast } = useToast();
  const mapData = [
    {
      value: '100',
      label: 'No. of token holders',
      icon: htt1(),
    },
    {
      value: '100',
      label: 'No. of token holders',
      icon: htt1(),
    },
    {
      value: '100',
      label: 'No. of token holders',
      icon: htt1(),
    },
  ];

  // const isContestVisible = useSelector(
  //     state => state.contestLeaderboardReducer.isContestVisible,
  // );
  const rewardDetail = useSelector(
    ({rewardsReducer}) => rewardsReducer?.rewardsDetailsMainData,
  );
  let userInfo = useSelector(({profile}) => profile.profileData);
  const insets = useSafeAreaInsets();
  const [modalVisible, setModalVisible] = useState(null);
  const dispatch = useDispatch();

  useFocusEffect(
    React.useCallback(() => {
      getDetails(rewardDetail);
    }, []),
  );

  async function getDetails(rewardDetail) {
    dispatch(getRewardsMainDetails());
  }

  const onLearnMore = () => {
    setModalVisible(null);
  };

  const onTradeTokenClick = param => {
    if (param === 'tokenEvent') {
      navigation.navigate('Fantasy', {
        screen: 'Tokens',
      });
    } else if (param === 'contest') {
      navigation.navigate('Fantasy', {
        screen: 'contestList',
      });
    }
  };

  const showToast = amount => {
    toast({
      title: `${amount} credits required for creating an event`,
      variant: 'info'
    });
  };

  const onEarnToken = (param, link) => {
    if (param === 'deposit') {
      navigation.navigate('WalletStack', {screen: 'WalletAdd'});
    }
    if (param === 'market') {
      navigation.navigate('RewardsStack', {screen: 'MarketMaking'});
    }
    if (param === 'opinionPoll') {
      if (!globalImport.isWeb) {
        navigation.navigate('RewardsStack', {screen: 'AskX'});
      } else {
        window?.CircleWidget?.open();
      }
    }
    if (param === 'createEvent') {
      userInfo?.create_normal_event_clickable
        ? navigation.navigate('RewardsStack', {
            screen: 'EventCreate',
            params: {
              isNormal: true,
            },
          })
        : showToast(userInfo?.create_normal_event_defaults?.invest_amount);
    }
  };

  return (
    <>
      {/*{isContestVisible ? (*/}
      {!rewardDetail && (
        <TouchableOpacity style={[styles.container]} activeOpacity={1}>
          <ActivityIndicator
            size="large"
            color={globalConfigurableData.loaderColor}
          />
        </TouchableOpacity>
      )}
      <View
        style={[
          {
            backgroundColor: Color.bgWhite,

            paddingTop: insets.top,
            //paddingBottom: insets.bottom,
            paddingLeft: insets.left,
            paddingRight: insets.right,
          },
          isMobile() ? globalStyle.scroll_webFix : {},
        ]}>
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName={"Rewards"}
          isBackgroundColor={false}
          translate={true}
          isBackBtnCallback={() => navigation.navigate('More')}
        />
        <ScrollView
          contentContainerStyle={{flexGrow: 1}}
          keyboardShouldPersistTaps="handled"
          nestedScrollEnabled={true}>
          <Gradient
            colors={[
              'rgba(127, 222, 255, 0.1)',
              '#ffffff',
              'rgba(255, 0, 0, 0.1)',
            ]}
            end={{x: 1, y: -1}}
            style={styles.topBox}>
            <View style={styles.rewardsBox}>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                }}>
                <View>
                  <FormTextLabel
                    labelStyles={{
                      ...globalFontStyle.appFontBody,
                      color: globalConfigurableData.secondaryTextColor1,
                    }}
                    label={'Token Balance'}
                  />
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      marginTop: 6,
                    }}>
                    <FastImage
                      style={{width: 22, height: 22}}
                      source={smile_coin()}
                    />
                    <Text
                      style={{
                        ...globalFontStyle.appBlueHead,
                        marginLeft: 5,
                        color: globalConfigurableData.primaryTextColor1,
                      }}>
                      {rewardDetail?.tokensProfile?.balance}
                    </Text>
                  </View>
                </View>
                <Text
                  style={{
                    ...globalFontStyle.appFontBody,
                    color: globalConfigurableData.primaryTextColor1,
                  }}>
                  {rewardDetail?.tokensProfile?.month}
                </Text>
              </View>
              <View
                style={{
                  borderRadius: 8,
                  backgroundColor: '#F9F9F9',
                  borderColor: '#CFCFCF',
                  borderWidth: 0.75,
                  marginTop: 15,
                }}>
                {rewardDetail?.tokensProfile?.meta?.map((item, index) => {
                  return (
                    <View
                      key={index}
                      style={[
                        {
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          paddingHorizontal: 10,
                          paddingVertical: 10,
                        },
                        index !== 0
                          ? {
                              borderTopWidth: 0.75,
                              borderColor: '#CFCFCF',
                            }
                          : null,
                      ]}>
                      <View
                        style={{
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        <Image
                          style={{width: 18, height: 18, marginRight: 8}}
                          source={{
                            uri: TEST_API + item?.icon,
                          }}
                        />
                        <Text
                          style={{
                            ...globalFontStyle.appFontBody,
                            color: globalConfigurableData.secondaryTextColor1,
                          }}>
                          {item.label}
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        <Text
                          style={{
                            ...globalFontStyle.appFontSubHeading,
                            color: globalConfigurableData.primaryTextColor1,
                          }}>
                          {item.value}
                        </Text>
                        {index === 2 && (
                          <FastImage
                            style={{width: 20, height: 20, marginRight: -5}}
                            source={profit_arrow()}
                          />
                        )}
                      </View>
                    </View>
                  );
                })}
              </View>
            </View>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: 15,
              }}>
              <TouchableOpacity
                onPress={() => {
                  setModalVisible('htt');
                }}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <FastImage
                  style={{width: 25, height: 25, marginRight: 8}}
                  source={htt_rewards()}
                />
                <FormTextLabel
                  label={'Tap to see how it works?'}
                  labelStyles={{
                    ...globalFontStyle.appFontBody,
                    color: globalConfigurableData.primaryTextColor1,
                  }}
                />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setModalVisible('pe');
                }}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <FastImage
                  style={{width: 20, height: 20, marginRight: 4}}
                  source={previous_earn_arrow()}
                />
                <FormTextLabel
                  label={'Previous Earnings'}
                  labelStyles={{
                    ...globalFontStyle.appFontBody,
                    color: globalConfigurableData.primaryBtnColor,
                  }}
                />
              </TouchableOpacity>
            </View>
          </Gradient>
          <View
            style={{
              marginVertical: 30,
              paddingHorizontal: 16,
            }}>
            <FormTextLabel
              labelStyles={[
                {
                  ...globalFontStyle.appFontTitle,
                  color: globalConfigurableData.primaryTextColor1,
                },
              ]}
              label={'Earn Tokens'}
            />
            <View style={{}}>
              {rewardDetail?.earnTokens?.map((item, index) => {
                if (
                  item?.key === 'create-event' &&
                  !userInfo?.create_normal_event_enabled
                ) {
                  return false;
                }
                return (
                  <TouchableOpacity
                    onPress={() => {
                      onEarnToken(
                        REWARDS_EARN_TOKENS[item?.key]?.redirect,
                        item?.link,
                      );
                    }}
                    key={index}>
                    <Gradient
                      colors={REWARDS_EARN_TOKENS[item?.key]?.colors}
                      locations={[0.017, 0.65]}
                      end={{x: 0.1, y: 0.4}}
                      style={[
                        styles.earnTokensBox,
                        {
                          borderColor:
                            REWARDS_EARN_TOKENS[item?.key]?.borderColors,
                        },
                      ]}>
                      <View
                        style={{
                          flex: 1,
                          marginVertical: 20,
                          marginHorizontal: 16,
                        }}>
                        <FormTextLabel
                          label={item?.title}
                          labelStyles={{
                            ...globalFontStyle.appFontHeading,
                            color: REWARDS_EARN_TOKENS[item?.key]?.borderColors,
                            marginBottom: 5,
                          }}
                        />
                        <FormTextLabel
                          label={item?.description}
                          labelStyles={{
                            ...globalFontStyle.appFontSmallText,
                            color: REWARDS_EARN_TOKENS[item?.key]?.borderColors,
                          }}
                        />
                      </View>
                      <Image
                        style={{width: 95, height: 95, marginRight: 5}}
                        source={{
                          uri: TEST_API + item?.img,
                        }}
                      />
                    </Gradient>
                  </TouchableOpacity>
                );
              })}
            </View>
          </View>
          <View
            style={{
              marginBottom: 150,

              paddingHorizontal: 16,
            }}>
            <FormTextLabel
              labelStyles={[
                {
                  ...globalFontStyle.appFontTitle,
                  color: globalConfigurableData.primaryTextColor1,
                },
              ]}
              label={'Trade Tokens'}
            />
            <View
              style={{
                flexDirection: 'row',
              }}>
              {rewardDetail?.tradeTokens?.map((item, index) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      onTradeTokenClick(
                        REWARDS_TRADE_TOKENS[item?.key]?.redirect,
                      );
                    }}
                    style={[REWARDS_TRADE_TOKENS[item?.key]?.styles]}>
                    <Gradient
                      colors={REWARDS_TRADE_TOKENS[item?.key]?.colors}
                      locations={[0.017, 0.65]}
                      end={{x: 0.1, y: 0.4}}
                      style={[styles.tradeTokensBox]}>
                      <View>
                        <FormTextLabel
                          label={item?.title}
                          labelStyles={{
                            ...globalFontStyle.appFontHeading,
                            color: globalConfigurableData.globalThemeColor,
                          }}
                        />
                        <FormTextLabel
                          label={item?.description}
                          labelStyles={{
                            ...globalFontStyle.appFontSmallText,
                            color: globalConfigurableData.globalThemeColor,
                          }}
                        />
                      </View>
                      <FastImage
                        style={{width: 25, height: 25, marginRight: 8}}
                        source={REWARDS_TRADE_TOKENS[item?.key]?.img()}
                      />
                    </Gradient>
                  </TouchableOpacity>
                );
              })}
            </View>
          </View>

          <CommonModal
            onModalCallBack={onLearnMore}
            showModal={modalVisible === 'htt'}
            customModalStyle={[globalStyle.modalView, {alignItems: 'stretch'}]}>
            <HowItWorksRewards
              onLearnMore={() => {
                setTimeout(() => {
                  onLearnMore();
                }, globalConst?.buttonTimer);
              }}
              httData={rewardDetail?.howItWorks}
            />
          </CommonModal>
          <CommonModal
            onModalCallBack={onLearnMore}
            showModal={modalVisible === 'pe'}
            customModalStyle={[globalStyle.modalView, {alignItems: 'stretch'}]}>
            <PreviousEarnings
              earningsDetail={rewardDetail?.previousEarnings}
              onLearnMore={() => {
                setTimeout(() => {
                  onLearnMore();
                }, globalConst?.buttonTimer);
              }}
            />
          </CommonModal>
        </ScrollView>
      </View>
      {/*// ) : (*/}
      {/*//     <ContestOnBoarding />*/}
      {/*// )}*/}
    </>
  );
};

export default RewardsMain;

const styles = StyleSheet.create({
  topBox: {
    paddingHorizontal: 16,
    backgroundColor: Colors.tradexBlue1,
    paddingBottom: 10,
  },
  rewardsBox: {
    marginTop: 20,
    paddingTop: 20,
    paddingBottom: 15,
    paddingHorizontal: 16,
    backgroundColor: globalConfigurableData.globalThemeColor,
    borderRadius: 8,
  },
  tradeTokensBox: {
    paddingVertical: 20,
    paddingHorizontal: 16,
    borderRadius: 12,
    height: 150,
    justifyContent: 'space-between',
  },
  earnTokensBox: {
    marginTop: 20,
    borderRadius: 12,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderWidth: 0.75,
  },
  container: {
    // flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    position: 'absolute',
    zIndex: 1111,
    top: 0,
    left: 0,
    height,
    width,
  },
});
